import { render, staticRenderFns } from "./assessHistory.vue?vue&type=template&id=26e55c70&scoped=true"
import script from "./assessHistory.vue?vue&type=script&lang=js"
export * from "./assessHistory.vue?vue&type=script&lang=js"
import style0 from "./assessHistory.vue?vue&type=style&index=0&id=26e55c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e55c70",
  null
  
)

export default component.exports